export default {
  options: {
    units: {
      kilometers: 'kilometers',
      meters: 'Meters',
      miles: 'Miles'
    },
    areUnits: {
      sqKms: 'km²',
      hectare: 'Hectare',
      sqMeters: 'm²'
    }
  }
}
